<template>
	<div id="my-account-page" data-aos="fade">
		<div class="account-layout">
			<!-- Sidebar -->
			<aside class="account-sidebar">
				<div class="sidebar-profile text-center mb-4">
					<div class="avatar-circle mx-auto mb-3">
						<i class="fa-regular fa-user"></i>
					</div>
					<h2 class="sidebar-name">{{ userName }}</h2>
					<p class="sidebar-email mb-0">{{ userEmail }}</p>
				</div>

				<nav class="sidebar-nav">
					<router-link
						to="/mi-cuenta/perfil"
						class="nav-link-item"
						active-class="active"
					>
						<i class="fa-regular fa-user"></i>
						<span>Edición de Perfil</span>
					</router-link>

					<router-link
						to="/mi-cuenta/expediente"
						class="nav-link-item"
						active-class="active"
					>
						<i class="fa-regular fa-file-lines"></i>
						<span>Mi Expediente</span>
					</router-link>

					<router-link
						to="/mi-cuenta/favoritos"
						class="nav-link-item"
						active-class="active"
					>
						<i class="fa-regular fa-heart"></i>
						<span>Mis favoritos</span>
					</router-link>

					<router-link
						to="/mi-cuenta/plan"
						class="nav-link-item"
						active-class="active"
					>
						<i class="fa-regular fa-credit-card"></i>
						<span>Mi Plan</span>
					</router-link>

					<router-link
						to="/mi-cuenta/lexi"
						class="nav-link-item"
						active-class="active"
					>
						<i class="fa-regular fa-robot"></i>
						<span>Lexi</span>
					</router-link>

					<button type="button" class="nav-link-item logout-btn mt-3" @click="handleLogout">
						<i class="fa-regular fa-right-from-bracket"></i>
						<span>Cerrar Sesión</span>
					</button>
				</nav>
			</aside>

			<!-- Contenido -->
			<main class="account-main">
				<router-view></router-view>
			</main>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MyAccountPage',

	data() {
		return {
			userName: '',
			userEmail: '',
		}
	},

	created() {
		const isLoggedIn = localStorage.getItem('userLoggedIn')
		if (!isLoggedIn) {
			this.$router.push('/login')
			return
		}
		this.userName = localStorage.getItem('userName') || 'Usuario'
		this.userEmail = localStorage.getItem('userEmail') || 'usuario@ejemplo.com'
	},

	methods: {
		handleLogout() {
			localStorage.removeItem('userLoggedIn')
			localStorage.removeItem('userName')
			localStorage.removeItem('userEmail')
			this.$router.push('/')
		},
	},
}
</script>
